/* istanbul ignore file */
import React, { forwardRef, useContext } from 'react';
import { makeStyles, shorthands } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import type { II18n, NotificationPlaceholderProp } from './types';

const useStyles = makeStyles({
  notificationPlaceholder: {
    width: '0px',
    ...shorthands.overflow('hidden'),

    '& .unified-notification-queue-container': {
      position: 'static',
    },
  },
});

export const NotificationPlaceHolderItem = forwardRef<HTMLDivElement, NotificationPlaceholderProp>(({ NotificationsBar, setIsActive }, ref) => {
  const classes = useStyles();
  const i18n: II18n = useContext(I18nContext);

  return (
    <div className={classes.notificationPlaceholder} ref={ref} tabIndex={-1}>
      <NotificationsBar i18n={i18n} setIsActive={setIsActive} forNewGlobalMenu />
    </div>
  );
});
